import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip/Tooltip';

interface ProjectMetadataProps {
	projectName: string;
}

const containerStyles = xcss({
	display: 'inline-block',
	maxWidth: '215px', // from Figma design
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

export const ProjectMetadata = ({ projectName }: ProjectMetadataProps): React.JSX.Element => {
	return (
		<Tooltip content={projectName}>
			{(tooltipProps) => (
				<Box xcss={containerStyles} testId="project-metadata" {...tooltipProps}>
					{projectName}
				</Box>
			)}
		</Tooltip>
	);
};
